import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Link,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField
} from '@material-ui/core';
import {
  AddCircleOutline,
  KeyboardArrowDown,
  KeyboardArrowUp,
  RemoveCircleOutline
} from '@material-ui/icons';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import classNames from 'classnames';
import { isNaN } from 'lodash';
import {
  getGochiMenus,
  editGochiMenu,
  addGochiMenuImage,
  EDIT_GOCHI_MENU_SUCCESS
} from '../../actions/GochiMenus';
import { resizeImage, sendLogin, uploadFile } from '../../auth/Auth';
import { languages, languageType } from '../../constants/Language';
import usageTypes from '../../constants/UsageType';
import listMenuChildTypes from '../../constants/MenuChildType';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUpload';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import MenuImageSampleGroupDialog from './MenuImageSampleGroupDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiMenuEditConfirmGroupV2 from './GochiMenuEditConfirmGroupV2';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 48,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '16px 0px 48px',
    paddingLeft: 16,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  title: {
    fontWeight: 700,
    fontSize: 27
  },
  editTable: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField: {
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  priceCalc: {
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    },
    verticalAlign: 'top',
    width: 44,
    minWidth: 44
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    },
    verticalAlign: 'top'
  },
  displayFlex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  displayFlexHelp: {
    display: 'flex',
    alignItems: 'end'
  },
  displayBlock: {
    display: 'block'
  },
  textMutiple: {
    paddingTop: '46px',
    width: '33px'
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  select: {
    width: '300px'
  },
  modal: {
    maxWidth: 1153,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  description: {
    fontWeight: 500,
    fontSize: 12
  },
  marginTop: {
    marginTop: 15
  },
  divHelp: {
    marginRight: 'auto'
  },
  divExplanation: {
    position: 'absolute',
    width: 280,
    top: 53,
    right: 21,
    zIndex: 10
  },
  textHelpExplainDiv: {
    padding: '10px 10px 0 10px'
  },
  textHelpExplain: {
    fontSize: 10
  },
  helpCloseBtn: {
    fontSize: 18,
    position: 'absolute',
    top: 3,
    right: 4,
    cursor: 'pointer'
  },
  helpCloseBtnWhite: {
    color: '#fff !important'
  },
  iconHelpEx: {
    color: 'gray !important',
    cursor: 'pointer'
  },
  positionRelative: {
    position: 'relative'
  },
  qaBox: {
    margin: '32px 0',
    padding: '0 16px'
  },
  headerNoteDonation: {
    fontSize: 16,
    fontWeight: 700,
    color: `${theme.palette.primary.main}`
  },
  answerNoteDonation: {
    display: 'flex',
    marginTop: 8
  },
  questionTextDonation: {
    fontSize: 18,
    fontWeight: 400
  },
  answerTextDonation: {
    fontSize: 16,
    fontWeight: 400,
    wordBreak: 'break-all'
  },
  handText: {
    fontSize: 20,
    fontWeight: 700,
    paddingLeft: 16
  },
  advancedSettingNote: {
    padding: '32px 16px'
  },
  paddingBottomNone: {
    paddingBottom: 0
  },
  btnContainer: {
    margin: '16px 0'
  },
  textFieldLong: {
    // padding: '0px 5px 0px 5px',
    minWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  notePriceVoucher: {
    fontSize: 14,
    color: '#F50057',
    marginTop: 16
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          editGochiMenu,
          addGochiMenuImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('shopId', 'setShopId', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('menuId', 'setMenuId', 0),
  withState('usageType', 'setUsageType', ''),
  withState('menuChildType', 'setMenuChildType', 1),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withState('description', 'setDescription', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('openAdvancedSetting', 'updateOpenAdvancedSetting', false),
  withState('expirationType', 'setExpirationType', 0),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 0; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('helpExpiration', 'setHelpExpiration', false),
  withState('helpDonation', 'setHelpDonation', false),
  withState('helpPriceCombo', 'setHelpPriceCombo', false),
  withState('shopGochiRestriction', 'setShopGochiRestriction', ''),
  withState(
    'openMenuImageSamplePopup',
    'updateOpenMenuImageSamplePopup',
    false
  ),
  withState('imageError', 'setImageError', ''),
  withState('isImageDefault', 'setIsImageDefault', false),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('showQADonation', 'setShowQADonation', false),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 0; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('comboMenu', 'setComboMenu', 0),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('subscription', 'setSubscription', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    defaultPrice: props => () => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;
      // TODO DBから取得
      let tax = 0.1;
      if (props.editInput.reducedTaxCheck) {
        tax = 0.08;
      }

      if (props.editInput.price !== '') {
        if (props.editInput.taxType === 'INTERNAL') {
          const amountTemp = parseFloat(
            (props.editInput.price / (1 + tax)).toFixed(9)
          );
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price - taxAmount;
        } else if (props.editInput.taxType === 'DONATION') {
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice = props.editInput.price;
        } else {
          includedTaxPrice =
            props.editInput.price + Math.round(props.editInput.price * tax);
          excludedTaxPrice = props.editInput.price;
        }
      }
      // props.setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const priceShow = includedTaxPrice
        ? parseInt(includedTaxPrice, 0).toString()
        : '0';
      props.setPriceCalc(`${priceShow} (税込み)`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setMenuId(this.props.editInput.menuId);
      this.props.setUsageType(this.props.editInput.usageType);
      this.props.setMenuChildType(this.props.editInput.menuChildType);
      this.props.setMenuName(this.props.editInput.menuName);
      this.props.setPreviewImage(this.props.editInput.image);
      this.props.setPrice(this.props.editInput.price);
      this.props.setTaxType(this.props.editInput.taxType);
      this.props.setReducedTaxType(this.props.editInput.reducedTaxType);
      if (this.props.editInput.reducedTaxType === 'REDUCED') {
        this.props.setReducedTaxCheck(true);
      }
      this.props.defaultPrice();
      if (this.props.editInput.menuGenreId) {
        this.props.setMenuGenreId(this.props.editInput.menuGenreId.toString());
      } else {
        this.props.setMenuGenreId(null);
      }
      this.props.setDescription(this.props.editInput.description);
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      this.props.setExpiration(this.props.editInput.expiration);
      if (this.props.editInput.expirationEndDate) {
        this.props.setExpirationType(1);
      } else if (this.props.editInput.expiration) {
        this.props.setExpirationType(0);
      } else {
        this.props.setExpirationType(2);
      }
      this.props.setExpirationEndDate(this.props.editInput.expirationEndDate);
      this.props.setShopGochiRestriction(
        this.props.editInput.shopGochiRestriction
      );
      this.props.setMenuLimitTotal(this.props.editInput.menuLimitTotal || 0);
      this.props.setPriceCombo(this.props.editInput.priceCombo);
      this.props.setQuantityRelease(this.props.editInput.quantityRelease);
      this.props.setComboMenu(this.props.editInput.comboMenu);
      this.props.setQuantityPromotion(this.props.editInput.quantityPromotion);
      this.props.setPromotionDescription(
        this.props.editInput.promotionDescription
      );
      this.props.setUsageLimit(this.props.editInput.usageLimit);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setShopId(this.props.editInput.shopId);
      this.props.setShopName(this.props.editInput.shopName);
      this.props.setSubscription(this.props.editInput.subscription);
      this.props.setSubscriptionIntervalCount(
        this.props.editInput.subscriptionIntervalCount
      );
      this.props.setSubscriptionInterval(
        this.props.editInput.subscriptionInterval
      );

      if (
        this.props.editInput.menuSituationIds &&
        this.props.editInput.menuSituationIds.length
      ) {
        this.props.setmenuSituationIds(
          this.props.editInput.menuSituationIds.map(String)
        );
      } else {
        this.props.setmenuSituationIds([]);
      }

      if (
        this.props.editInput.menuUserTargetIds &&
        this.props.editInput.menuUserTargetIds.length
      ) {
        this.props.setmenuUserTargetIds(
          this.props.editInput.menuUserTargetIds.map(String)
        );
      } else {
        this.props.setmenuUserTargetIds([]);
      }

      let dataFirst = {};
      const origilData = {
        shopId: null,
        menuChildType: null,
        comboMenu: null,
        menuLimitTotal: null,
        groupId: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        shopName: null,
        menuName: null,
        price: null,
        priceCalc: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        numberUsePerDay: null,
        expirationType: null,
        expiration: null,
        expirationEndDate: null,
        description: null,
        taxType: null,
        reducedTaxType: null,
        tagStr: null,
        tags: null,
        updatedAt: null,
        menuGenreId: null,
        menuGenreName: null,
        menuSituationIds: [],
        menuUserTargetIds: []
      };
      dataFirst = origilData;
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    searchKey,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    message,
    setMessage,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    errorMessage,
    setErrorMessage,
    checkSession,
    shopId,
    shopName,
    menuId,
    usageType,
    menuChildType,
    editInput,
    menuName,
    setMenuName,
    menuNameError,
    setMenuNameError,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    priceError,
    setPriceError,
    taxTypes,
    taxType,
    setTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuGenre,
    menuGenreError,
    setMenuGenreError,
    description,
    setDescription,
    tagStr,
    setTagStr,
    tags,
    setTags,
    openAdvancedSetting,
    updateOpenAdvancedSetting,
    expirationType,
    setExpirationType,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    setExpirationEndDate,
    minExpirationDate,
    maxExpirationDate,
    expirationList,
    helpExpiration,
    setHelpExpiration,
    helpDonation,
    setHelpDonation,
    helpPriceCombo,
    setHelpPriceCombo,
    shopGochiRestriction,
    openMenuImageSamplePopup,
    updateOpenMenuImageSamplePopup,
    isImageDefault,
    setIsImageDefault,
    imageError,
    setImageError,
    menuImageSampleList,
    menuLimitTotal,
    setMenuLimitTotal,
    showQADonation,
    setShowQADonation,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityReleaseList,
    comboMenu,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    promotionDescription,
    setPromotionDescription,
    usageLimit,
    setUsageLimit,
    updatedAt,
    multiLangData,
    setMultiLangData,
    translateType,
    isLanguage,
    reducedTaxMenuPrefix,
    subscriptionInterval,
    subscriptionIntervalCount,
    subscription,
    menuSituationIds,
    menuUserTargetIds
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;
    const IMAGE_DEFAULT_VOUCHER = '/images/background_voucher.png';
    const IMAGE_DEFAULT_COMBO = '/images/background_combo.png';

    const errors = {
      menuNameError,
      priceError,
      menuGenreError,
      expirationError,
      imageError,
      priceComboError,
      quantityReleaseError,
      quantityPromotionError
    };

    const addWaterMark = async inputPrice => {
      const canvas = await new Promise(resolve => {
        let objectURL = '';
        if (usageType === USAGE_TYPE_VOUCHER) {
          objectURL = IMAGE_DEFAULT_VOUCHER;
        } else if (usageType === USAGE_TYPE_COMBO) {
          objectURL = IMAGE_DEFAULT_COMBO;
        }
        const c = document.createElement('canvas');
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.canvas.width = img.width;
          ctx.canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          ctx.fillStyle = 'black';
          ctx.font =
            "700 100px 'Yu Gothic', 'Roboto', 'Helvetica', 'Arial', sans-serif";
          const tempPrice = parseInt(inputPrice, 10);
          const textString = isNaN(tempPrice)
            ? ''
            : `${tempPrice.toLocaleString()}${
                usageType === USAGE_TYPE_VOUCHER ? '円' : '円分'
              }`;
          const textWidth = ctx.measureText(textString).width;
          ctx.fillText(
            textString,
            ctx.canvas.width / 2 - textWidth / 2,
            ctx.canvas.height / 2
          );
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/png',
          1
        );
      });
    };

    const renderImageDefault = async (inputPrice, isClick) => {
      // handle asynchronous when render image from price
      window.priceRenderImageMenu = inputPrice;
      let fileName = '';
      if (!isImageDefault && previewImage && !isClick) {
        return;
      }
      if (usageType === USAGE_TYPE_VOUCHER) {
        fileName = `${shopName || editInput.groupName}の${inputPrice}円商品券`;
      } else if (usageType === USAGE_TYPE_COMBO) {
        fileName = `${shopName || editInput.groupName}の${inputPrice}円回数券`;
      }
      const newBlob = await addWaterMark(inputPrice);
      const blob = new Blob([newBlob], { type: 'image/png' });
      const newImage = new File([blob], `${fileName}.png`, {
        type: blob.type
      });
      const reader = new FileReader();
      reader.readAsDataURL(newImage);
      setImage(newImage);
      setIsImageDefault(true);
      setImageError('');
      reader.onloadend = () => {
        if (inputPrice === window.priceRenderImageMenu) {
          setPreviewImage(reader.result);
        }
      };
    };

    const autoRenderDescription = () => {
      if (usageType === USAGE_TYPE_COMBO) {
        if (
          quantityPromotion &&
          quantityPromotion !== '0' &&
          promotionDescription
        ) {
          setDescription(
            `${shopName ||
              editInput.groupName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (quantityPromotion && quantityPromotion !== '0') {
          setDescription(
            `${shopName ||
              editInput.groupName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (promotionDescription) {
          setDescription(
            `${shopName ||
              editInput.groupName}のつかえる回数券です。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else {
          setDescription(
            `${shopName ||
              editInput.groupName}のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        }
      }
    };

    useEffect(() => {
      autoRenderDescription();
    }, [quantityPromotion, promotionDescription]);

    const getUsageTypeName = usageTypeId => {
      if (usageTypeId) {
        const usageTypeName = usageTypes.find(
          usage => usage.id.toString() === usageTypeId.toString()
        ).name;
        return usageTypeName;
      }
      return '';
    };

    const getMenuChildTypeName = menuChildTypeId => {
      if (menuChildTypeId) {
        let menuChildTypeName = listMenuChildTypes.find(
          childType => childType.id.toString() === menuChildTypeId.toString()
        ).name;
        if (menuChildTypeId === 1) {
          menuChildTypeName = '店舗指定';
        } else if (menuChildTypeId === 4) {
          menuChildTypeName = 'グループ全体';
        }
        return menuChildTypeName;
      }
      return '';
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };

    const handleAddImage = imageInput => {
      setPreviewImage(imageInput);
      setIsImageDefault(false);
      setImageError('');
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const handleShowHelpExpiration = () => {
      setHelpExpiration(true);
    };

    const handleShowHelpDonation = () => {
      setHelpDonation(true);
    };

    const handleShowHelpPriceCombo = () => {
      setHelpPriceCombo(true);
    };

    const handleCloseHelpPopup = () => {
      setHelpPriceCombo(false);
      setHelpExpiration(false);
      setHelpDonation(false);
    };

    const ref = useRef();

    const handleClose = e => {
      if (helpPriceCombo) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPriceCombo(false);
        }
      }
      if (helpExpiration) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpExpiration(false);
        }
      }
      if (helpDonation) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpDonation(false);
        }
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClose);
      return () => {
        document.removeEventListener('click', handleClose);
      };
    });

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      if (e.target.id === 'isDonation') {
        if (e.target.checked) {
          latestTaxType = 'DONATION';
        } else {
          latestTaxType = 'INTERNAL';
        }
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }

      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log(excludedTaxPrice);
      const val =
        e.target.id !== 'reducedTax' &&
        typeof e.target.id !== 'undefined' &&
        e.target.id !== 'isDonation'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };

    const validMenuName = () => {
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };

    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      if (parseInt(value, 10) > 999999999) {
        setPriceError('999,999,999円以下ご入力ください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };

    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        setMenuGenreError('必須項目です。');
        return 1;
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };

    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };

    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };

    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '' || !value) {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };

    const validExpiration = () => {
      const value = expiration;
      if (value === '' || !value) {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const validImageMenu = () => {
      const value = previewImage;
      if (!value) {
        setImageError('必須項目です。');
        return 1;
      }
      setImageError('');
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      const validMenuNameCount = validMenuName();
      const validImageMenuCount =
        usageType === USAGE_TYPE_MENU ? 0 : validImageMenu();
      // Menu normal
      if (comboMenu === 0) {
        errorCount =
          validMenuNameCount +
          validImageMenuCount +
          validPrice() +
          validMenuGenre();
      } else if (comboMenu === 1) {
        // Menu combo
        errorCount =
          validMenuNameCount +
          validImageMenuCount +
          validPriceCombo() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre();
      }

      if (
        (validMenuNameCount > 0 || validImageMenuCount > 0) &&
        usageType !== USAGE_TYPE_MENU
      ) {
        updateOpenAdvancedSetting(true);
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        shopId,
        menuName,
        description,
        price,
        taxType,
        reducedTaxType,
        tags,
        updatedAt,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expiration,
        expirationEndDate,
        menuCombo: comboMenu,
        priceCombo,
        menuGenreId,
        menuSituationIds,
        menuUserTargetIds,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        usageType,
        shopName,
        tagStr,
        menuLimitTotal,
        menuChildType
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMultiLangData(getCurrentData());
        updateOpenEditConfirm(true);
      }
    };

    const cancelAction = () => updateOpenEdit(false);

    const backAction = () => updateOpenEditConfirm(false);

    const editAction = async () => {
      setLoading(true);
      updateOpenProgress(true);
      const editedMenu = await actions
        .editGochiMenu(menuId, multiLangData)
        .then(data => checkSession(data));

      if (editedMenu.type === EDIT_GOCHI_MENU_SUCCESS) {
        if (typeof image !== 'undefined' && image !== null) {
          let imageData = image;
          if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
            const { resizeImageFile } = await resizeImage(imageData);
            imageData = resizeImageFile;
          }
          const imagePath = await uploadFile(
            'menu',
            menuId,
            imageData,
            'public'
          );
          await actions
            .addGochiMenuImage(menuId, {
              image: imagePath
            })
            .then(data => checkSession(data));
        }
        setMessage('編集が完了しました。');
      } else {
        setErrorMessage('編集に失敗しました。');
        updateOpenProgress(false);
      }
      setLoading(false);
    };

    const progressOkAction = async () => {
      setLoading(true);
      await actions.getGochiMenus(searchKey).then(data => checkSession(data));
      setLoading(false);
      updateOpenEdit(false);
      updateOpenEditConfirm(false);
      updateOpenProgress(false);
      setMessage('');
    };

    return (
      <>
        <div className={classes.root}>
          <div className={classes.pageTitle}>
            <Typography className={classes.title}>メニュー編集</Typography>
          </div>

          <div>
            <Typography
              className={classes.handText}
              style={{ paddingBottom: 16 }}
            >
              {`用途: ${getUsageTypeName(usageType)}`}
            </Typography>
            <Typography
              className={classes.handText}
              style={{ paddingBottom: 32 }}
            >
              {`対象: ${getMenuChildTypeName(menuChildType)} `}
            </Typography>
          </div>

          <Table className={classes.editTable}>
            <TableBody>
              {parseInt(editInput.menuChildType, 10) !== 4 && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      required
                      fullWidth
                      label="店舗名"
                      defaultValue={editInput.shopName}
                      className={classes.textField}
                      InputProps={{
                        readOnly: true
                      }}
                      variant="filled"
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
              {usageType === USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        fullWidth
                        label="メニュー名"
                        defaultValue={editInput.menuName}
                        inputProps={{
                          maxLength: 250
                        }}
                        value={menuName}
                        className={classes.textField}
                        onChange={e => {
                          setMenuName(e.target.value);
                        }}
                        onBlur={validMenuName}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      <ValidationText message={errors.menuNameError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <FormLabel className={classes.description}>
                        メニュー画像
                      </FormLabel>
                      {/* <div>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          className={classes.button}
                          onClick={() => updateOpenMenuImageSamplePopup(true)}
                        >
                          デフォルト画像を選択
                        </Button>
                      </div> */}
                      <FileUpload
                        label="image"
                        file={image}
                        setFile={setImage}
                        previewImage={previewImage}
                        setPreviewImage={handleAddImage}
                      />
                      <div className={classes.textExplain}>
                        ※8MB以内でお願いします。
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              )}
              {usageType === USAGE_TYPE_COMBO ? (
                <>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colLeft,
                        classes.paddingBottomNone
                      ]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell
                      className={classNames(
                        classes.tableCellBorderNone,
                        classes.colRight,
                        classes.positionRelative,
                        classes.paddingBottomNone
                      )}
                    >
                      <div className={classes.displayFlexHelp}>
                        <div className={classes.divHelp}>
                          <Typography className={classes.description}>
                            単価×発行枚数
                          </Typography>
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpPriceCombo}
                        />
                        {helpPriceCombo && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CardMedia
                                component="img"
                                width="280"
                                className={classes.media}
                                image="images/help_comboPrice.png"
                                title="Menu price explaination"
                              />
                              <CloseIcon
                                className={[
                                  classes.helpCloseBtn,
                                  classes.helpCloseBtnWhite
                                ]}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  className={classes.textHelpExplain}
                                >
                                  メニュー名の後に表示される回数券の「単価」と「発行枚数」です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                      style={{ paddingTop: 8 }}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                      style={{ paddingTop: 8 }}
                    >
                      <div className={classes.displayFlex}>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="priceCombo"
                            required
                            label="単価"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={priceCombo}
                            onChange={e => {
                              setPriceCombo(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validPriceCombo}
                          />
                          <ValidationText message={errors.priceComboError} />
                        </div>
                        {/* <div className={classes.priceCalc}>{priceCalc}</div> */}
                        <div className={classes.textMutiple}>円 x</div>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="quantityRelease"
                            name="quantityRelease"
                            select
                            required
                            label="発行枚数"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={quantityRelease}
                            InputProps={{
                              shrink: true
                            }}
                            onChange={e => {
                              setQuantityRelease(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validQuantityRelease}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          <ValidationText
                            message={errors.quantityReleaseError}
                          />
                        </div>
                        <div className={classes.textMutiple}>枚</div>
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      id="price"
                      fullWidth
                      disabled={
                        editInput.comboMenu === 1 ||
                        usageType === USAGE_TYPE_VOUCHER
                      }
                      required
                      label="価格"
                      defaultValue={editInput.price}
                      className={classes.textField}
                      value={price}
                      onChange={e => {
                        const tempPrice = e.target.value.trim();
                        setPrice(tempPrice);
                        calcPrice(e);
                        if (usageType === USAGE_TYPE_VOUCHER) {
                          const priceText = isNaN(parseInt(tempPrice, 10))
                            ? ''
                            : parseInt(tempPrice, 10).toLocaleString();
                          renderImageDefault(tempPrice, false);
                          setMenuName(`GOCHI ${priceText}円券`);
                          setMenuNameError('');
                          setDescription(
                            `${shopName ||
                              editInput.groupName}の${priceText}円分使える商品券です。プレゼントにどうぞ。`
                          );
                        }
                      }}
                      onBlur={validPrice}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <ValidationText message={errors.priceError} />
                    <div className={classes.priceCalc}>{priceCalc}</div>
                    {usageType === USAGE_TYPE_VOUCHER && (
                      <div className={classes.notePriceVoucher}>
                        ※商品券の価格変更をご希望される場合は、新規でメニューを追加し、ご希望の価格を設定した代替の商品券メニューを作成してください。
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <div>
                    <TextField
                      id="taxType"
                      fullWidth
                      name="taxType"
                      select
                      label="税区分 *"
                      className={classes.textField}
                      value={taxType === 'DONATION' ? 'INTERNAL' : taxType}
                      onChange={e => {
                        setTaxType(e.target.value.trim());
                        calcPrice(e);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      disabled={
                        taxType === 'DONATION' || usageType !== USAGE_TYPE_MENU
                      }
                    >
                      {taxTypes
                        .filter(group => {
                          return group.id !== 'DONATION';
                        })
                        .map(group => {
                          return (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </div>
                  {usageType === USAGE_TYPE_MENU && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            id="reducedTax"
                            checked={reducedTaxCheck}
                          />
                        }
                        label="軽減税率対象"
                        onChange={e => {
                          setReducedTaxCheck(e.target.checked);
                          convertReducedTax(e.target.checked);
                          calcPrice(e);
                        }}
                      />
                      <div style={{ fontSize: 14 }}>
                        価格の消費税の設定をお願いします。
                        <br />
                        ・外税
                        <br />
                        ・内税
                        <br />
                        ※テイクアウトの場合は、「軽減税率対象」にチェックを入れてください。
                      </div>
                    </>
                  )}
                </TableCell>
              </TableRow>
              {usageType === USAGE_TYPE_COMBO && (
                <>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        id="quantityPromotion"
                        name="quantityPromotion"
                        select
                        isClearable
                        label="付与無料枚数"
                        className={classes.textField}
                        margin="normal"
                        value={quantityPromotion}
                        InputProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          setQuantityPromotion(e.target.value);
                        }}
                        onBlur={validQuantityPromotion}
                      >
                        {quantityReleaseList.map(item => {
                          return (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                      <ValidationText message={errors.quantityPromotionError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        label="おまけ"
                        className={classes.textFieldLong}
                        margin="normal"
                        onChange={e => {
                          setPromotionDescription(e.target.value);
                        }}
                        inputProps={{
                          maxLength: 1000
                        }}
                        value={promotionDescription}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    select
                    label="ジャンル *"
                    className={[classes.textField, classes.textFieldLong]}
                    margin="normal"
                    value={menuGenreId}
                    onChange={e => {
                      setMenuGenreId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validMenuGenre}
                  >
                    {menuGenre &&
                      menuGenre.map(item => {
                        return (
                          <MenuItem
                            key={item.menuGenreId}
                            value={item.menuGenreId}
                          >
                            {item.menuGenreName}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                  <ValidationText message={errors.menuGenreError} />
                </TableCell>
              </TableRow>
              {usageType === USAGE_TYPE_MENU && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <AnyButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      label="説明"
                      multiline
                      fullWidth
                      rows="4"
                      defaultValue={editInput.description}
                      onChange={e => {
                        setDescription(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={description}
                      inputProps={{
                        maxLength: 250
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    label="タグ"
                    defaultValue={editInput.tagStr}
                    value={tagStr}
                    onChange={e => {
                      setTagStr(e.target.value);
                      splitTagStr(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    fullWidth
                  />
                  <div
                    className={`${classes.description} ${classes.marginTop}`}
                  >
                    #おすすめ #おふくろの味 #学生に ＃ガッツリ
                    などメニューの特徴を表すタグを記載できます。
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div className={classes.advancedSettingNote}>
            <div
              className={classes.displayFlexHelp}
              onClick={() => updateOpenAdvancedSetting(!openAdvancedSetting)}
              aria-hidden="true"
              style={{ cursor: 'pointer', alignItems: 'flex-start' }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 700
                }}
                className={classes.divHelp}
              >
                高度な設定
              </div>
              {openAdvancedSetting ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )}
            </div>
            <div style={{ marginTop: 8, fontSize: 16 }}>
              以下の高度な設定は必須ではありません。詳細設定を希望される場合のみご利用ください。高度な設定により、ご利用条件・ご利用期間などが異なります。項目の詳細を十分にご理解いただいたうえで、設定をお願いいたします。
            </div>
          </div>
          {openAdvancedSetting && (
            <>
              <Table className={classes.editTable}>
                <TableBody>
                  {usageType !== USAGE_TYPE_MENU && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <RequiredButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            required
                            fullWidth
                            label="メニュー名"
                            defaultValue={editInput.menuName}
                            inputProps={{
                              maxLength: 250
                            }}
                            value={menuName}
                            className={classes.textField}
                            onChange={e => {
                              setMenuName(e.target.value);
                            }}
                            onBlur={validMenuName}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                          <ValidationText message={errors.menuNameError} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <RequiredButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <FormLabel className={classes.description}>
                            メニュー画像
                          </FormLabel>

                          {!isImageDefault && (
                            <div>
                              <Button
                                variant="outlined"
                                color="primary"
                                component="span"
                                className={classes.button}
                                onClick={() => renderImageDefault(price, true)}
                                disabled={price === ''}
                              >
                                デフォルト画像を選択
                              </Button>
                            </div>
                          )}

                          <FileUpload
                            label="image"
                            file={image}
                            setFile={setImage}
                            previewImage={previewImage}
                            setPreviewImage={handleAddImage}
                          />
                          <ValidationText message={errors.imageError} />
                          <div className={classes.textExplain}>
                            ※8MB以内でお願いします。
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            label="説明"
                            multiline
                            fullWidth
                            rows="4"
                            defaultValue={editInput.description}
                            onChange={e => {
                              setDescription(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                            value={description}
                            inputProps={{
                              maxLength: 250
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                  {usageType === USAGE_TYPE_COMBO && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone,
                            classes.colLeft
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone,
                            classes.colRight
                          ]}
                        >
                          <Typography
                            component="div"
                            className={classNames(
                              classes.labelText,
                              classes.labelControl,
                              classes.description
                            )}
                          >
                            利用制限
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                          style={{ paddingTop: 8 }}
                        />
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                          style={{ paddingTop: 8 }}
                        >
                          <div>
                            <RadioGroup
                              row
                              value={usageLimit}
                              onChange={e => {
                                setUsageLimit(parseInt(e.target.value, 10));
                              }}
                            >
                              <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="なし"
                              />
                              <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="1日1枚"
                              />
                            </RadioGroup>
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colLeft,
                        classes.paddingBottomNone
                      ]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={classNames(
                        classes.colRight,
                        classes.positionRelative,
                        classes.tableCellBorderNone,
                        classes.paddingBottomNone
                      )}
                    >
                      <div className={classes.displayFlexHelp}>
                        <div className={classes.divHelp}>
                          <Typography className={classes.description}>
                            利用期間
                          </Typography>
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpExpiration}
                        />
                        {helpExpiration && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CloseIcon
                                className={classes.helpCloseBtn}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography className={classes.textHelpExplain}>
                                  【指定しない】
                                  <br />
                                  購入日から180日間ご利用いただけます。
                                  <br />
                                  <br />
                                  【期限指定】
                                  <br />
                                  利用できる期限日を日付で指定して設定できます。
                                  <br />
                                  例）〜3月31日まで→購入日に関わらず3月31日まで利用可能
                                  <br />
                                  <br />
                                  【期間指定】
                                  <br />
                                  チケットを購入してから利用できる期間を日数で指定して設定できます。
                                  <br />
                                  例）30日間利用可能→購入日が1月1日の場合、1月31日まで利用可能
                                  <br />
                                  ※チケットの利用期間は最長で購入日から180日間です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.paddingBottomNone, classes.colLeft]}
                      style={{ paddingTop: 8 }}
                    />
                    <TableCell
                      className={[classes.paddingBottomNone, classes.colRight]}
                      style={{ paddingTop: 8 }}
                    >
                      <RadioGroup
                        row
                        value={expirationType}
                        onChange={e => {
                          setExpirationType(parseInt(e.target.value, 10));
                          resetExpirationValue();
                        }}
                      >
                        <FormControlLabel
                          value={2}
                          control={<Radio color="primary" />}
                          label="指定しない"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="期限指定"
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="期間指定"
                        />
                      </RadioGroup>
                      {expirationType === 0 && (
                        <TextField
                          id="expiration"
                          name="expiration"
                          select
                          label="利用期間"
                          className={classes.textField}
                          margin="normal"
                          value={expiration}
                          InputProps={{
                            shrink: 'true'
                          }}
                          onChange={e => {
                            setExpiration(e.target.value);
                          }}
                          // variant="filled"
                        >
                          {expirationList.map(item => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      )}
                      {expirationType === 1 && (
                        <TextField
                          label="終了"
                          type="date"
                          className={classes.textField}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={expirationEndDate}
                          inputProps={{
                            min: minExpirationDate,
                            max: maxExpirationDate
                          }}
                          onChange={e => {
                            setExpirationEndDate(e.target.value);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                  {usageType === USAGE_TYPE_VOUCHER && (
                    <TableRow>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                        style={{ paddingTop: 32 }}
                      >
                        <AnyButton />
                      </TableCell>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                        style={{ paddingTop: 32 }}
                      >
                        <Typography
                          component="div"
                          className={classNames(
                            classes.labelText,
                            classes.labelControl
                          )}
                        >
                          利用方法
                        </Typography>
                        <div style={{ maxWidth: 706 }}>
                          <RadioGroup
                            row
                            value={menuLimitTotal}
                            onChange={e => {
                              setMenuLimitTotal(parseInt(e.target.value, 10));
                            }}
                            style={{ flexWrap: 'nowrap' }}
                          >
                            <div>
                              <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="一円単位利用"
                                disabled
                              />
                              <div className={classes.noteText}>
                                残高が無くなるまで、一円単位で任意の金額を指定してご利用いただけます。
                              </div>
                            </div>
                            <div style={{ marginLeft: 24, marginRight: 82 }}>
                              <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="一枚単位利用"
                                disabled
                              />
                              <div className={classes.noteText}>
                                額面が決まっているチケットを一枚ずつご利用いただけます。お釣りは出ません。
                              </div>
                            </div>
                          </RadioGroup>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                  {usageType !== USAGE_TYPE_COMBO && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft,
                            classes.paddingBottomNone
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={classNames(
                            classes.colRight,
                            classes.positionRelative,
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone
                          )}
                        >
                          <div className={classes.displayFlexHelp}>
                            <div className={classes.divHelp}>
                              <Typography className={classes.description} />
                            </div>
                            <HelpIcon
                              className={classes.iconHelpEx}
                              onClick={handleShowHelpDonation}
                            />
                            {helpDonation && (
                              <div ref={ref} className={classes.divExplanation}>
                                <Card>
                                  <CloseIcon
                                    className={classes.helpCloseBtn}
                                    onClick={handleCloseHelpPopup}
                                  />
                                  <CardContent
                                    className={classes.textHelpExplainDiv}
                                  >
                                    <Typography
                                      className={classes.textHelpExplain}
                                      style={{ margin: '20px 0 0' }}
                                    >
                                      設定すると自動的に「誰でもごち」になり、税率が0％になります。
                                      <br />
                                      誰でもごちとは？
                                      <br />
                                      自分用やギフト用に購入するのではなく、「お店に寄付」してお店を訪れた不特定の相手にご利用いただく「ごち（チケット）」です。
                                      <br />
                                      詳細はマニュアルをご確認ください。
                                      <br />
                                      {`マニュアル： `}
                                      <Link
                                        href="https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/"
                                        target="_blank"
                                        color="primary"
                                      >
                                        https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/
                                      </Link>
                                      <br />
                                      ※チケットのご利用には、ユーザー登録が必要です。
                                      <br />
                                      ※店頭に専用QRコードをご用意いただき、ユーザー様のスマートフォンで読み取っていただく事でチケットを呼び出せます。
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.paddingBottomNone,
                            classes.colLeft
                          ]}
                        />
                        <TableCell
                          className={[
                            classes.paddingBottomNone,
                            classes.colRight
                          ]}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox id="isDonation" color="primary" />
                            }
                            label="寄付設定"
                            checked={taxType === 'DONATION'}
                            onChange={e => {
                              if (e.target.checked) {
                                setTaxType('DONATION');
                              } else {
                                setTaxType('INTERNAL');
                              }
                              calcPrice(e);
                            }}
                            disabled={shopGochiRestriction === 'MENTION_ONLY'}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
              <div className={classes.qaBox} style={{ maxWidth: 343 }}>
                <div
                  className={classes.displayFlex}
                  style={{ alignItems: 'flex-start' }}
                >
                  <div className={classes.divHelp}>
                    <span className={classes.headerNoteDonation}>Q.</span>
                    <span className={classes.questionTextDonation}>
                      金額を非表示にするには？
                    </span>
                  </div>
                  {showQADonation ? (
                    <RemoveCircleOutline
                      color="primary"
                      onClick={() => setShowQADonation(false)}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <AddCircleOutline
                      color="primary"
                      onClick={() => setShowQADonation(true)}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </div>
                {showQADonation && (
                  <div className={classes.answerNoteDonation}>
                    <div className={classes.headerNoteDonation}>A.</div>
                    <div className={classes.answerTextDonation}>
                      <div>
                        ギフト券の場合、金額を非表示にすることが可能です。
                        <br />
                        ご要望がある場合はお問い合わせください。
                      </div>
                      <div style={{ marginTop: 8 }}>お問い合わせフォーム</div>
                      <div>
                        <Link
                          href="https://support.gigi.tokyo/contact/contact01/"
                          target="_blank"
                          color="primary"
                        >
                          https://support.gigi.tokyo/contact/contact01/
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          <div className={classes.btnContainer}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <ConfirmButton onClickAction={confirmAction} />
          </div>
        </div>

        <Modal open={openMenuImageSamplePopup} className={classes.modal}>
          <MenuImageSampleGroupDialog
            handleClose={() => updateOpenMenuImageSamplePopup(false)}
            menuImageSampleList={menuImageSampleList}
            setPreviewImage={setPreviewImage}
            setIsImageDefault={setIsImageDefault}
            setImageError={setImageError}
          />
        </Modal>

        <Modal open={openEditConfirm} className={classes.modal}>
          <GochiMenuEditConfirmGroupV2
            backAction={backAction}
            editAction={editAction}
            editConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            currentLanguage={isLanguage}
            previewImage={previewImage}
            menuId={menuId}
            menuGenreName={menuGenreName}
            usageTypeName={getUsageTypeName(editInput.usageType)}
            menuChildTypeName={getMenuChildTypeName(menuChildType)}
          />
        </Modal>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
